"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonSkeletonAbilityHandler = exports.SummonSkeletonActorAbilityFactory = exports.SummonSkeletonAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const __1 = require("../..");
class SummonSkeletonAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SummonSkeleton;
        this.__typeName = "SummonSkeleton";
    }
}
exports.SummonSkeletonAbilityArgs = SummonSkeletonAbilityArgs;
let SummonSkeletonActorAbilityFactory = class SummonSkeletonActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SummonSkeleton", "Self", 1);
    }
};
SummonSkeletonActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SummonSkeleton")
], SummonSkeletonActorAbilityFactory);
exports.SummonSkeletonActorAbilityFactory = SummonSkeletonActorAbilityFactory;
let SummonSkeletonAbilityHandler = class SummonSkeletonAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const skeletonArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.NecromancerSkeleton, invoker.level, 
                // attributes...
                Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = 1;
                    switch (+key) {
                        case __1.AttributeType.Power:
                            value = (0, __1.getValueOrDefault)(invoker.maxAttributeValues, __1.AttributeType.Focus, 0);
                            break;
                        case __1.AttributeType.Focus:
                            value = (0, __1.getValueOrDefault)(invoker.maxAttributeValues, __1.AttributeType.Power, 0);
                            break;
                    }
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {
                    [__1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("SkeletalSlice").mk(),
                    [__1.AbilitySlot.Ability2]: Registries_1.ActorAbilities.getItem("Taunt").mk(),
                })
                    .withPlayerId(invoker.playerId);
                container.summonCompanion(sequence, ability.invokerId, skeletonArgs);
                if (container.hasAttribute(ability.invokerId, "Charm_Necromancer_1")) {
                    container.summonCompanion(sequence, ability.invokerId, skeletonArgs);
                }
            }
        });
    }
};
SummonSkeletonAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SummonSkeleton)
], SummonSkeletonAbilityHandler);
exports.SummonSkeletonAbilityHandler = SummonSkeletonAbilityHandler;
